import * as actionTypes from "./actionTypes";
import axios from "axios";
import api from "../../shared/api";

export const correctionStart=()=>{
    return {
        type:actionTypes.CORRECTION_START
    }
};

export const correctionSuccess=()=>{
    return {
        type:actionTypes.CORRECTION_SUCCESS
    }
}

export const correctionFail=(err)=>{
    return {
        type:actionTypes.CORRECTION_FAIL,
        payload:err
    }
}

export const correction=(request,token)=>{
    return async dispatch=>{
        dispatch(correctionStart());
        let url=`${api}/transactions/correction`;
        const options = {
            url: url,
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: request
        };
        await axios(options)
            .then(response => {
                dispatch(correctionSuccess());
            })
            .catch(err => {
                dispatch(correctionFail('Correction failed ' + err));
            });
    }
}